import { defineSlotRecipe } from '@chakra-ui/react'

export const imageCard = defineSlotRecipe({
  className: 'ImageCard',
  slots: ['figure', 'caption', 'figcaption', 'heading', 'subHeading', 'link'],
  base: {
    figure: {
      '& img': {
        borderRadius: 'lg',
      },
    },
    figcaption: {
      color: 'brand.coolgrey10',
    },
    heading: {
      fontSize: 'lg',
      fontWeight: 'semibold',
      marginTop: '1.5rem',
    },
    subHeading: {
      fontSize: 'lg',
      fontWeight: 'medium',
    },
    caption: {
      marginTop: '0.75rem',
    },
  },
})
